'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
export default class StatusBarSection extends PureComponent {
  render() {
    const {
      alignRight,
      label
    } = this.props;
    const sectionClassName = 'status-bar-section' + (alignRight ? " align-right" : "");
    return /*#__PURE__*/_jsx("div", {
      className: sectionClassName,
      children: label
    });
  }

}
StatusBarSection.propTypes = {
  label: PropTypes.node.isRequired,
  alignRight: PropTypes.bool
};
StatusBarSection.defaultProps = {
  label: ''
};